<template>
  <div>
    <v-autocomplete
      ref="autocompleteRef"
      v-model="categorySelected"
      :items="listCategories"
      :loading="isLoading"
      :disabled="isLoading"
      @change="setCategoryName"
      :label="$t('filterByCategories')"
      item-text="name"
      item-value="name"
      prepend-icon="mdi-filter-variant"
      dense
      filled
      solo-inverted
      clearable
      hide-details
      return-object
      :no-data-text="$t('autoCompleteNoData')"
      @click:clear="clearable()"
      :rules="rules"
    >
      <template v-slot:item="{item}">
        <v-icon :color="handleColorStatus(item.status)" x-small left>mdi-circle</v-icon> {{ item.name }} {{ item.status }}
      </template>

      <template v-slot:selection="{item}">
        <v-chip small>
          <v-icon
            :color="handleColorStatus(item.status)"
            x-small
            left
          >mdi-circle</v-icon>
          {{ item.name }}
          <span
            v-show="item.status == 0"
            class="ml-2"
          >({{ statusUI(item.status)}})</span><!-- {{ item.name }} {{ item.status }}-->
        </v-chip>
      </template>

      <template v-slot:item="{item}">
        <!-- <v-chip small> -->
          <v-icon
            :color="handleColorStatus(item.status)"
            x-small
            left
          >mdi-circle</v-icon>
          {{ item.name }}
          <span
            v-show="item.status == 0"
            class="ml-2"
          >({{ statusUI(item.status)}})</span><!-- {{ item.name }} {{ item.status }}-->
        <!-- </v-chip> -->
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
export default {
  name: "components-common-filter-autocomplete-casino-categories",
  props: ["rules"],
  data: () => ({
    categorySelected: null,
    isLoading: false,
    listCategories: [],
    search: null,
  }),

  computed: {
    casinoLobby() {
      return this.$store.state.filters.selectCasinoLobby.value
    },

    isListGamesOrListCategories() {
      return this.$route.name == "ListGames" ||
              this.$route.name == "CollaboratorListGames"
    }
  },

  mounted() {
    if (
      this.$route.name === "ListGames" ||
      this.$route.name === "CasinoListBetOnline" ||
      this.$route.name === "CollaboratorListGames" || 
      this.$route.name === "CollaboratorCasinoListBetOnline"
    ) {
      this.fetchListCategories();
    }
  },

  watch: {
    casinoLobby() {
      if (
        this.$route.name === "ListGames" ||
        this.$route.name === "CasinoListBetOnline" ||
        this.$route.name === "CollaboratorListGames" ||
        this.$route.name === "CollaboratorCasinoListBetOnline"
      ) {
        this.fetchListCategories();
        this.categorySelected = []
        this.$store.commit("setCasinoCategoryName", "");
        
      } else if (
        this.$route.name === 'ListCategories' ||
        this.$route.name === 'CollaboratorListCategories'
        ) {
        this.categorySelected = []
        this.$store.commit("setCasinoCategoryName", "");
      }
    },

    // Essa verificação é útil para atualizar o componente
    // Quando o usuário cria uma nova categoria, assim
    // o componente é atualizado e a nova categoria é mostrada
    $route(val) {
      if (
        val.name === 'ListGames' ||
        val.name === 'CasinoListBetOnline' ||
        val.name === "CollaboratorListGames" ||
        val.name === "CollaboratorCasinoListBetOnline"
      ) {
        this.fetchListCategories()
      }
    }
  },

  methods: {
    clearable() {
      this.$store.commit("setCasinoCategoryName", "");
    },

    setCategoryName() {
      if (this.isListGamesOrListCategories) {
        this.$store.commit("setCasinoCategoryName",
          this.categorySelected ?
            this.categorySelected.name : ""
        );
      }

      if (
        this.$route.name === "CasinoListBetOnline" ||
        this.$route.name === "CollaboratorCasinoListBetOnline"
      ) {
        this.$store.commit("setCasinoCategoryName",
          this.categorySelected ?
            this.categorySelected.id : ""
        );
      }
    },

    async fetchListCategories() {
      this.isLoading = true;
      this.listCategories = [];
      const body = {
        live: this.casinoLobby
      }
      this.$axios
      .post(
        `${this.$prefix()}/cassino/GamesAgregation/ListCategories`,
          this.$formdata(body)
      )
      .then((response) => {
        this.listCategories = response.data.dados
        // Armazena no vuex para usar
        // a lista no select do datatable em listGames ADM e Colab
        this.$store.commit("setCasinoCategoriesList", this.listCategories);
      }).catch(() => {})
      .finally(() => this.isLoading = false)
    },

    handleColorStatus(status) {
      if (status == 0) return "grey";
      if (status == 1) return "green";
    },

    statusUI(value) {
      const obj = {
        0: `${this.$t( "inativa" )}`,
        1: `${this.$t( "ativa" )}`,
      };
      return obj[value];
    },
  },
};
</script>
